export function formatMarketCap(value: number): string {
  const oku = value / 100_000_000
  return `${Math.round(oku).toLocaleString()}億円`
}
